<template>
  <content-box class="change-plan--wrap" :width="'970px'">
    <div class="modal-container">
      <div class="modal">
        <i class="icon icon--close-size16 modal-close" @click="onCloseLayer"></i>
        <div class="modal-header">{{ $t('pricing.option.selected') }}</div>
        <div class="modal-body">
          <div class="step-by-price-area" :class="newPlanName">
            <template v-for="(step, index) in steps">
              <div class="step-wrap" :class="`step_${index + 1}`" :key="index">
                <div class="step-title">{{ step.title }}</div>
                <div class="step-contents" v-if="newPlan.planNumber !== 300 || index === 0">
                  <div class="content-card left" :class="{selected: isSelected(index), disabled: isDisabled(index) || newPlanName === 'Agency'}"
                      @click="!isDisabled(index) && checkOption(index, 'type1')">
                    <div class="content-card-title">{{ step.options.type1.main }}</div>
                    <div class="content-card-detail">
                      <div class="item">{{ step.options.type1.detail[0] }}</div>
                    </div>
                    <div class="content-card-check"></div>
                  </div>
                  <div class="content-card right"   :class="{selected: !isSelected(index),disabled: newPlan.planNumber === 300 }"
                      @click="checkOption(index, 'type2')">
                    <div class="content-card-title">
                      {{ step.options.type2.main }}
                    </div>
                    <div class="content-card-detail">
                      <div class="item">{{ step.options.type2.detail[0] }}</div>
                    </div>
                    <div class="content-card-check"></div>
                  </div>
                </div>
                <!-- every plan의 결제 수단-->
                <div class="step-contents" v-if="newPlan.planNumber === 300 && index === 1">
                  <div class="content-card left" :class="{selected: true, disabled: isDisabled(index) || newPlanName === 'Agency'}"
                       @click="checkOption(index, 'type2')">
                    <div class="content-card-title">{{ $t('pricing.useFree') }}</div>
                    <div class="content-card-detail">
                      <div class="item">{{ $t('pricing.useFreeText') }}</div>
                    </div>
                    <div class="content-card-check"></div>
                  </div>
                </div>
              </div>
            </template>
            <div class="step-wrap referral" ref="referral">
              <div class="referral-title">
                <i class="icon icon--star-badge size-26"></i>
                <p>{{ $t('referral.referralCode') }} {{ $t('common.optional') }}</p>
                <p class="referral-benefit">{{ $t('pricing.option.referral.benefit') }}</p>
              </div>
              <div :class="['referral-next', {'disabled' : isMonthlyDisabled}]" v-if="this.nextReferral && useNextReferralCode">
                <p>{{ this.nextReferral }}</p>
                <button @click="useNextReferralCode = false">
                  <i class="icon icon--close14"></i>
                </button>
              </div>
              <template v-else>
                <div class="referral-code">
                  <ui-input-text :type="'text'"
                                 :disabled="isMonthlyDisabled"
                                  :id="'newReferralCode'"
                                  :placeholder="$t('common.placeHolder.enterReferralCode')"
                                  :modelError="referralCodeError"
                                  :modelValue="newReferralCode"
                                  @input="onReferralCodeInput">
                  </ui-input-text>
                  <button v-if="heatmapReferralCode && heatmapReferralCode !== nextReferral" :class="['get-code-button', { 'disabled': gotHeatmapReferralCode || isMonthlyDisabled }]" :disabled="gotHeatmapReferralCode || isMonthlyDisabled" @click="getHeatmapReferralCode">
                    <i class="icon icon--arrow-left-blue"></i>
                    <p>UX Heatmap{{ $t('referral.getCode') }}</p>
                  </button>
                </div>
                <div class="referral-term" v-if="isReferralTermRequired">
                  <div class="referral-term-header">
                    <ui-checkbox :value="isReferralTermAgreed" @input="onChangeReferralTermAgreed">
                    </ui-checkbox>
                    <p class="term-title">
                      <a class="link" :href="referralTermsUrl" target="_blank">{{ $t('referral.register.term.title') }}</a>
                      <span class="necessary">{{ $t('referral.register.term.sub') }}</span>
                    </p>
                    <button :class="['term-toggle', { 'opened': isReferralTermOpened }]" @click="isReferralTermOpened = !isReferralTermOpened">
                      <i class="icon icon--arrow-dropdown"></i>
                    </button>
                    <p v-show="isReferralTermError" class="term-error">
                      {{ $t('common.validationErrorText.referralTerm') }}
                    </p>
                  </div>
                  <ul v-show="isReferralTermOpened" class="term-list">
                    <li v-html="$t('referral.register.term.1')"></li>
                    <li v-html="$t('referral.register.term.2')"></li>
                    <li v-html="$t('referral.register.term.3')"></li>
                  </ul>
                </div>
              </template>
            </div>
          </div>
          <div class="total-price-area">
            <div class="plan-name-wrap">
              <div class="plan-name">
                {{ newPlanName }}
                <ui-button class="plan-select-btn" @click="openNewPlanPage">
                  {{ $t('pricing.planSelectBtn') }}
                  <i class="icon icon--link-deep size-12"></i>
                </ui-button>
              </div>
              <ul class="plan-available">
                <li>{{ newPlanPv | thousand }}PV / {{ $t(`pricing.${newPlanInfo.periodType}`)}}</li>
                <li>AI DOCENT {{newPlan.docentCredit}}{{ $t('pricing.count') }} / {{ $t(`pricing.${newPlanInfo.periodType}`)}}</li>
                <li v-if="newPlan.planNumber !== 300 && newPlan.planNumber !== 401">
                  JAM {{ newPlan.jam | thousand }}{{ $t('pricing.ea') }} / {{ $t(`pricing.${newPlanInfo.periodType}`)}}
                ({{ $t('pricing.maxAiReport', {report:newReportCredit}) }})
                </li>
              </ul>
            </div>
            <div class="plan-info-wrap">
              <div class="item usePeriod">
                <span>{{ $t('pricing.usePeriod') }}</span>
                <div class="frame">
                  {{ $t(`pricing.periodType.${ selectionStates[0].type1 ? 'monthly' : 'yearly' }`)}}
                </div>
              </div>
              <div class="item paymentType">
                <span>{{ $t('pricing.payment') }}</span>
                <div class="frame" v-if="newPlan.planNumber === 300">
                  {{ $t('plan.free') }}
                </div>
                <div class="frame" v-else>
                  {{ $t(`pricing.paymentType.${selectionStates[1].type1 ? 'credit' : 'bank'}`)}}
                </div>
              </div>
              <!-- <div class="item">
                <span>{{ $t('pricing.planFee') }}</span>
                <div class="frame">
                  {{ originPrice | thousand }}{{ $t('pricing.currencyUnit')}}
                </div>
              </div> -->
              <div class="item" v-if="referralCode">
                <span>{{ $t('pricing.referralDiscount') }}</span>
                <div class="frame">
                  {{planReferralDiscount}}
                </div>
              </div>
              <div class="item" v-if="newPlanName !== 'Agency' && selectionStates[0].type2">
                <span>{{ $t('pricing.annualDiscount') }}</span>
                <div class="frame">
                  {{ newPlan.planNumber === 401? $t('pricing.selectStarter') : $t('pricing.tenPercentDiscount') }}
                </div>
              </div>
            </div>
            <div class="plan-total-wrap">
              <div>
                <div class="total-price">
                  {{ discountedPrice | thousand }}{{ $t('pricing.currencyUnit') }}
                </div>
                <div class="price-per-month">
                  <template v-if="newPlan.planNumber === 300">
                    {{ $t('pricing.monthlyFee') }} {{ $t('plan.free') }}
                  </template>
                  <template v-else>
                  {{ $t('pricing.monthlyFee') }} {{ monthlyFee | thousand }}{{ $t('pricing.currencyUnit') }}({{ $t('pricing.noVat') }})
                  </template>
                </div>
              </div>
              <div class="price-btn-wrap" :class="{ disabled: errors.pv || errors.report || (newPlan.planNumber === currentPlan.planNumber && selectionStates[0].type1 && selectionStates[1].type1) } ">
                <div class="plan-apply-btn" v-if="newPlan.planNumber === currentPlan.planNumber && selectionStates[0].type1 && selectionStates[1].type1" @click="onContactUs">
                  {{ $t('plan.planInUse') }}
                </div>
                <div class="plan-apply-btn" v-else-if="selectionStates[0].type2 || selectionStates[1].type2 || currentPlan.applyType === 'admin'" @click="onContactUs">
                  {{ $t('pricing.contactUs') }}
                </div>
                <div class="plan-apply-btn" v-else @click="onPlanChange">{{ $t('common.confirm') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </content-box>
</template>
<script>
import { mapState } from 'vuex'
import { getCurrentNext } from '@/api/userPlan'
import { checkReferExist, checkReferValidate } from '@/api/referral'

import ContentBox from '@/components/ui/ContentBox'
import UiInputText from '@/components/ui/UiInputText'
import UiCheckbox from '@/components/ui/UiCheckbox'
import { homeUrl, thousand } from '../../../libs/utils'
import UiButton from '@/components/ui/UiButton.vue'
import { IS_PRODUCTION } from '@/libs/constants'

export default {
  components: {
    UiButton,
    ContentBox,
    UiInputText,
    UiCheckbox
  },
  props: [
    'newPlan'
  ],
  data () {
    return {
      hasTermsError: false,
      isTermsAgree: false,
      showPlanList: false,
      planInfo: {
        everyone: {
          type: 'Everyone',
          periodType: 'month',
          pv: 300000
        },
        starter: {
          type: 'Starter',
          periodType: 'month',
          pv: 600000
        },
        basic: {
          type: 'Basic',
          periodType: 'month',
          pv: 1000000
        },
        standard: {
          type: 'Standard',
          periodType: 'month',
          pv: 2000000
        },
        premium: {
          type: 'Premium',
          periodType: 'month',
          pv: 3000000
        },
        pro: {
          type: 'Pro',
          periodType: 'month',
          pv: 4000000
        }
      },
      showTooltip: false,
      isCheckOption: [
        true,
        this.$i18n.locale === 'en' || this.$i18n.locale !== 'ja'
      ],
      selectionStates: [],
      newReferralCode: '',
      heatmapReferralCode: '',
      referralCodeError: '',
      useNextReferralCode: true,
      isReferralTermRequired: true,
      isReferralTermAgreed: false,
      isReferralTermOpened: true,
      isReferralTermError: false,
      gotHeatmapReferralCode: false,
      lang: this.$i18n.locale,
      currentPlan: {},
      nextPlan: {},
      newPlanPv: 0,
      newReportCredit: 0,
      newPlanInfo: {},
      errors: {
        pv: null,
        report: null
      }
    }
  },
  computed: {
    ...mapState([
      'userData'
    ]),
    planReferralDiscount () {
      if (this.newPlan.planNumber === 300) {
        return this.$t('pricing.selectFree')
      }
      if (this.newPlan.planNumber === 401) {
        return this.$t('pricing.selectStarter')
      }
      return this.$t('pricing.tenPercentDiscount')
    },
    isMonthlyDisabled () {
      return this.newPlan.planNumber === this.currentPlan.planNumber && this.isSelected(0)
    },
    steps () {
      return [
        {
          title: this.$t('pricing.option.type1.title'),
          options: {
            type1: {
              main: this.$t('pricing.option.type1.main'),
              detail: [
                this.$t('pricing.option.type1.detail1')
              ]
            },
            type2: {
              main: this.$t('pricing.option.type1.main2'),
              detail: [
                this.$t('pricing.option.type1.detail2')
              ],
              desc: this.$t('pricing.option.type1.desc2')
            }
          }
        },
        {
          title: this.$t('pricing.option.type2.title'),
          options: {
            type1: {
              main: this.$t('pricing.option.type2.main'),
              detail: [this.$t('pricing.option.type2.detail')]
            },
            type2: {
              main: this.$t('pricing.option.type2.main2'),
              detail: [
                this.$t('pricing.option.type2.detail2')
              ]
            }
          }
        }
      ]
    },
    newPlanName () {
      return this.newPlan.planName.indexOf('Agency') > -1 ? 'Agency' : this.newPlan.planName
    },
    isYearly () {
      return this.selectionStates[0].type2
    },
    nextReferral () {
      return this.nextPlan && this.nextPlan.referral
    },
    referralCode () {
      if (this.nextReferral && this.useNextReferralCode) {
        return this.nextReferral
      }
      return this.newReferralCode
    },
    isPaymentType () {
      return this.selectionStates[1].type1 ? 'card' : 'bank'
    },
    totalPrice () {
      let originPrice = 0
      originPrice = this.newPlan.originPrice
      return originPrice
    },
    discountedPrice () {
      let price = this.totalPrice
      const excludedPlans = [300, 401]
      const isExcluded = excludedPlans.includes(this.newPlan.planNumber)

      if (this.isYearly && this.newPlan.planName.indexOf('Agency') === -1) {
        if (isExcluded) {
          price = (price * 12)
        } else {
          price = (price * 12) * 0.9
        }
      }

      if (this.referralCode && !isExcluded) {
        price = price * 0.9
      }

      return price
    },
    monthlyFee () {
      if (this.isYearly) {
        return Math.round(this.discountedPrice / 12)
      } else {
        return this.discountedPrice
      }
    },
    referralTermsUrl () {
      return `${process.env.VUE_APP_HOME_URL}/${this.$i18n.locale}/referralTerms`
    }
  },
  watch: {
    newPlan () {
      getCurrentNext({}, true).then(res => {
        this.currentPlan = res.currentPlan
        this.nextPlan = res.nextPlan
      })

      this.newPlanPv = this.newPlan.pvLimit
      this.newReportCredit = this.newPlan.jam / 10

      if (this.newPlan && this.newPlan.planName === 'Custom') {
        this.newPlanPv = '300,000'
        this.newPlanInfo.pv = 300000
        this.newReportCredit = 0
      }
      this.newPlanInfo = this.planInfo[this.newPlan.planName.toLowerCase()]
      if (this.newPlanInfo.periodType === 'year') {
        this.selectionStates = [
          { type1: false, type2: true }, // Step 1
          { type1: false, type2: true } // Step 2
        ]
      }
    }
  },
  created () {
    const isLocaleEnOrJa = this.$i18n.locale === 'en' || this.$i18n.locale === 'ja'
    this.selectionStates = [
      { type1: true, type2: false }, // Step 1
      { type1: !isLocaleEnOrJa, type2: isLocaleEnOrJa } // Step 2
    ]
    getCurrentNext({}, false).then(res => {
      this.currentPlan = res.currentPlan
      this.nextPlan = res.nextPlan

      // 변경 플랜이 300(무료)이면 기본값 유지
      if (this.newPlan.planNumber === 300 || this.$i18n.locale !== 'ko') {
        return
      }

      // 현재 플랜 기간 체크 (2개월 이상이면 연간, 아니면 월간)
      let isYearly = false
      if (this.currentPlan.useStartDate && this.currentPlan.useEndDate) {
        const start = new Date(this.currentPlan.useStartDate)
        const end = new Date(this.currentPlan.useEndDate)
        const diffMonths = (end - start) / (1000 * 60 * 60 * 24 * 30)
        isYearly = diffMonths > 2
      }

      // 현재 플랜 결제 방식 체크
      const isWire = this.currentPlan.paymentType === 'wire transfer' || this.currentPlan.paymentType === '4grit'

      // Vue 반응성을 위해 배열 전체 교체
      this.selectionStates = [
        { type1: !isYearly, type2: isYearly },
        { type1: !isWire, type2: isWire }
      ]
    })
    this.newPlanPv = this.newPlan.pvLimit
    this.newReportCredit = this.newPlan.jam / 10
    if (this.newPlan && this.newPlan.planName === 'Custom') {
      this.newPlanPv = '300,000'
      this.newPlanInfo.pv = 300000
      this.newReportCredit = 0
    }

    console.log(this.planInfo)
    console.log(this.newPlan.planName)

    this.newPlanInfo = this.planInfo[this.newPlan.planName.toLowerCase()]
    if (this.newPlanInfo.periodType === 'year') {
      this.selectionStates = [
        { type1: false, type2: true }, // Step 1
        { type1: false, type2: true } // Step 2
      ]
    }

    checkReferExist({ userId: this.userData.userId })
      .then(res => {
        this.heatmapReferralCode = res.referral
        this.isReferralTermRequired = !res.terms
      })
      .catch(e => {
        console.error(e)
      })
  },
  methods: {
    openNewPlanPage () {
      const position = 'plan-explain'
      const url = `${homeUrl}/${this.$i18n.locale}/userjourneymap/pricing?position=${encodeURIComponent(position)}`
      window.open(url, '_blank')
      this.onCloseLayer()
    },
    /**
     * 요금제 변경 옵션 선택
     * @param {number} index
     * @param {string} type
     */
    checkOption (index, type) {
      if (!this.isDisabled(index)) {
        if (type === 'type1') {
          if (this.nextReferral) {
            this.useNextReferralCode = true
            this.newReferralCode = ''
          } else if (this.nextReferral && index === 0) {
            this.newReferralCode = ''
          }
          this.selectionStates[index].type1 = true
          this.selectionStates[index].type2 = false
        } else if (type === 'type2') {
          this.selectionStates[index].type1 = false
          this.selectionStates[index].type2 = true
        }
      }
    },
    /**
     * 이전 단계로 이동
     */
    goPrevStep () {
      this.$emit('onBack')
    },
    /**
     * 선태한 항목
     */
    isSelected (index) {
      return this.selectionStates[index].type1
    },
    /**
     * 비활성화 여부
     */
    isDisabled (index) {
      if (this.newPlan.planNumber === 300) return false
      const isLastIndex = index === this.steps.length - 1
      return (isLastIndex && this.lang === 'en') || (isLastIndex && this.lang === 'ja')
    },
    async onContactUs () {
      if (await this.hasReferralError()) return
      // if (this.selectionStates[0].type2 || this.selectionStates[1].type2) {
      //   if (this.selectionStates[0].type2) {
      //     this.$emit('contactUs', false, true, true)
      //   } else {
      //     this.$emit('contactUs', false, true)
      //   }
      // } else {
      //   this.$emit('contactUs', true)
      // }
      const planInfo = {
        product: this.newPlanName,
        price: this.discountedPrice,
        yearly: this.isYearly,
        paymentType: this.isPaymentType,
        pvLimit: this.newPlan.pvLimit,
        aiReportCredit: this.newPlan.aiReportCredit,
        referral: this.referralCode
      }
      this.$emit('contactUs', planInfo)
    },
    async hasReferralError () {
      let hasError = false

      if (this.referralCode) {
        let isReferralCodeValid = null
        await checkReferValidate({ referral: this.referralCode, userId: this.userData.userId })
          .then(res => {
            isReferralCodeValid = res
          })
          .catch(e => {
            console.error(e)
          })

        if (!isReferralCodeValid) {
          this.referralCodeError = isReferralCodeValid === false
            ? 'duplicatedReferralCode'
            : 'invalidReferralCode'
          hasError = true
        }
        if (this.isReferralTermRequired && !this.isReferralTermAgreed) {
          this.isReferralTermError = true
          hasError = true
        }
      } else if (this.isReferralTermAgreed) {
        this.referralCodeError = 'emptyReferralCode'
        hasError = true
      }

      if (hasError) {
        const referral = this.$refs.referral
        if (referral) {
          referral.scrollIntoView({ behavior: 'smooth' })
          const referralInput = referral.querySelector('#newReferralCode')
          if (referralInput) {
            setTimeout(() => {
              referralInput.focus()
            }, 400)
          }
        }
      }

      return hasError
    },
    async onPlanChange () {
      if (await this.hasReferralError()) return

      this.newPlanInfo.price = this.discountedPrice
      this.newPlanInfo.originPrice = this.totalPrice
      this.newPlanInfo.referral = this.referralCode

      this.$emit('onPlanChange', true, this.newPlanInfo, true)
      // if (this.newPlan.planName === 'Custom') {
      // } else {
      //   this.$emit('onPlanChange', true)
      // }
    },
    onCloseLayer () {
      this.$emit('closeLayer')
    },
    selectAgencyReport (type) {
      // this.newPlanInfo.type = `Agency${type}`
      // this.newPlanInfo.report = type === 150 ? 2000000 : 3000000
      // this.newPlanInfo.cxReport = type
      const changeTypeNumber = type === 150 ? 2000 : 2001
      this.$emit('change', changeTypeNumber)
    },
    checkNumberValidation ({ target }) {
      const num = target.value.replaceAll(',', '')

      const type = target.name
      if (type === 'pv') {
        if (isNaN(num)) {
          this.errors[type] = 'onlyNum'
        } else if (num < 300000) {
          this.errors[type] = 'customMinValue'
        } else if (num % 100000 > 0) {
          this.errors[type] = 'fixedUnit'
        } else {
          this.errors[type] = null
          this.newPlanInfo.pv = Number(num)
          this.newPlanPv = thousand(num)
        }
      }
      if (type === 'report') {
        if (isNaN(num) || num === '') {
          this.errors[type] = 'onlyNum'
        } else {
          this.errors[type] = null
          this.newPlanInfo.cxReport = Number(num)
          this.newReportCredit = thousand(num)
        }
      }
    },
    onChangeReferralTermAgreed (value) {
      this.isReferralTermAgreed = value
      this.isReferralTermError = false
    },
    onReferralCodeInput (value) {
      this.newReferralCode = value.trim()
      this.referralCodeError = ''
      if (this.gotHeatmapReferralCode) {
        this.gotHeatmapReferralCode = false
      }
    },
    getHeatmapReferralCode () {
      this.newReferralCode = this.heatmapReferralCode
      this.gotHeatmapReferralCode = true
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.change-plan--wrap {
  box-shadow: none;
  height: 653px;
  .modal-container {
    position: relative;
    min-width: 200px;
    min-height: 200px;
    border-radius: 1em;
    overflow: hidden;
    transition: all 500ms ease;
    z-index: 0;
    .modal {
      position: relative;
      background-color: #fff;
      width: 970px;
      height: 653px;
      z-index: 0;
      .modal-close {
        cursor: pointer;
        position: absolute;
        top: 12px;
        right: 12px;
        z-index: 100;
      }
      .modal-header {
        position: absolute;
        width: 100%;
        padding: 30px;
        box-sizing: border-box;
        font-size: 15px;
        font-weight: 500;
        color: #2F2F2F;
        background: linear-gradient(180deg, #FFF 69.77%, rgba(255, 255, 255, 0.00) 100%);
        z-index: 10;
        text-align: left;
      }
      .modal-body {
        display: flex;
        flex-direction: column;
        height: 100%;
        .total-price-area {
          color: #2f2f2f;
          box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.16), 0px 0px 0px 1px rgba(0, 0, 0, 0.16);
          flex-shrink: 0;
          display: flex;
          padding: 24px 28px;
          min-height: 170px;
          box-sizing: border-box;
          position: relative;
          z-index: 1
        ;
          .plan {
            &-name-wrap {
              min-width: 308px;
              .plan-name {
                font-size: 30px;
                font-weight: 600;
                line-height: 1;
                margin-bottom: 12px;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .plan-select-btn {
                  padding: 0 10px;
                  font-size: 12px;
                  font-weight: 600;
                  height: 28px;
                  &:deep {
                    .text {
                      display: flex;
                      align-items: center;
                      gap: 4px;
                    }
                  }
                }
              }
              .plan-available {
                color: #444;
                font-size: 13px;
                font-weight: 500;
                line-height: 120%;
                display: flex;
                gap: 8px;
                flex-direction: column;

                li {
                  text-align: left;
                }

                .plan-select-btn {
                  padding: 0 10px;
                  font-size: 12px;
                  font-weight: 600;
                  height: 28px;
                  &:deep {
                    .text {
                      display: flex;
                      align-items: center;
                      gap: 4px;
                    }
                  }
                }
              }
              .plan-detail {
                color: #444;
                font-size: 13px;
                font-weight: 600;
                text-align: left;
              }
            }
            &-info-wrap {
              padding-top: 24px;
              padding-left: 24px;
              margin-left: 24px;
              max-width: 257px;
              width: calc(100% - 24px);
              display: flex;
              flex-direction: column;
              gap: 10px;
              border-left: 1px solid  rgba(0, 0, 0, 0.16);
              .item {
                position: relative;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 13px;
                font-weight: 500;
                line-height: 1.15;
                color: #444;
                z-index: 1;
                &:before {
                  content: '';
                  position: absolute;
                  top: 50%;
                  transform: translateY(-50%);
                  left: 0;
                  z-index: -1;
                  width: 99%;
                  height: 1px;
                  background-image: linear-gradient(to right,transparent 50%, #D7D7D7 50%);
                  background-size: 5px 1px;
                }
                span {
                  background-color: #fff;
                }
                .frame {
                  background-color: #fff;
                }
              }
            }
            &-total-wrap {
              padding-top: 24px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              text-align: right;
              margin-left: auto;
              .total-price {
                font-size: 26px;
                font-weight: 600;
                margin-bottom: 10px;
              }
              .price-per-month {
                color: #444;
                font-size: 13px;
                font-weight: 500;
                line-height: 1.2;
                margin-bottom: 10px;
              }
              .price-btn-wrap {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                gap: 5px;
                .plan-prev-btn {
                  cursor: pointer;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  gap: 6px;
                  box-sizing: border-box;
                  min-width: 0;
                  padding: 10px 18px;
                  border: 1px solid #bbb;
                  border-radius: 20px;
                  background-color: #fff;
                  font-size: 14px;
                  font-weight: 600;
                  color: #444;
                  line-height: 1;
                }
                .plan-apply-btn {
                  cursor: pointer;
                  display: inline-flex;
                  justify-content: center;
                  align-items: center;
                  box-sizing: border-box;
                  min-width: 124px;
                  padding: 12px 14px;
                  border-radius: 20px;
                  background-color: #ec0047;
                  font-size: 14px;
                  font-weight: 600;
                  line-height: 1;
                  color: #fff;
                }
                &.disabled {
                  .plan-apply-btn {
                    pointer-events: none;
                    background-color: #ccc;
                  }
                }
              }
            }
          }
        }
        .step-by-price-area {
          flex-grow: 1;
          overflow-y: auto;
          padding: 30px;
          margin-top: 45px;
          counter-reset: list-counter;
          .step-wrap {
            padding: 26px 0;
            border-top: 1px dashed #D7D7D7;
            .step-title{
              text-align: left;
              position: relative;
              color: #2F2F2F;
              font-size: 15px;
              display: flex;
              align-items: center;
              gap: 10px;
              &:before {
                counter-increment: list-counter;
                content: counter(list-counter);
                border: 1px solid #D7D7D7;
                border-radius: 50em;
                width: 30px;
                height: 30px;
                color: #666;
                display: flex;
                align-items: center;
                justify-content: center;

              }
            }
            .step-contents {
              display: flex;
              justify-content: center;
              gap: 20px;
              padding: 14px 40px;
              .content-card {
                cursor: pointer;
                position: relative;
                width: 50%;
                flex-grow: 1;
                padding: 24px;
                border: 1px solid #AFAFAF;
                border-radius: 8px;
                color: #2F2F2F;
                min-height: 120px;
                box-sizing: border-box;
                text-align: left;
                .content-card-title {
                  font-size: 24px;
                  font-weight: 700;
                  line-height: 1;
                  margin-bottom: 18px;

                  .icon.icon-beta {
                    width: 37px;
                    height: 15px;
                  }
                }
                .content-card-detail {
                  font-size: 13px;
                  font-weight: 400;
                  line-height: 1;
                  display: flex;
                  flex-direction: column;
                  gap: 12px;
                  .item {
                    display: flex;
                    align-items: center;
                    gap: 5px;
                    span {
                      line-height: 1;
                    }
                    span.sub-info {
                      color: #767676;
                    }
                    &.coming-soon {
                      color: #BBBBBB;
                    }
                    .label-btn {
                      color: #BBB;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      font-size: 7px;
                      line-height: 7px;
                      border: 1px solid #BBBBBB;
                      border-radius: 4px;
                      padding: 3px 5px 2px;
                      letter-spacing: .1px;
                    }

                    .tooltip-container {
                      position: relative;
                      i.link-icon {
                        position: relative;
                        display: inline-block;
                        width: 15px;
                        height: 15px;
                        background: url("https://dream-cdn.beusable.net/home/images/icon-info.svg") no-repeat center center;
                        background-size: cover;
                      }

                      .tooltip {
                        min-width: 275px;
                        min-height: 122px;
                        position: absolute;
                        top: 25px;
                        left: 50%;
                        transform: translateX(-50%);
                        z-index: 5;
                        border-radius: 8px;
                        box-shadow: 0px 23px 15px -12px rgba(0, 0, 0, 0.08), 0px 0px 0px 1px rgba(0, 0, 0, 0.08);
                        background-color: #ffffff;
                        padding: 20px;
                        box-sizing: border-box;
                        opacity: 1;
                        //display: none;
                        transition: all .3s;

                        .arrow {
                          content: '';
                          background-color: #fff;
                          position: absolute;
                          z-index: 2;
                          transform: rotate(-45deg);
                          width: 10px;
                          height: 10px;
                          -webkit-box-shadow: 1px -1px 0 0 rgba(0, 0, 0, 0.16);
                          box-shadow: 1px -1px 0 0 rgba(0, 0, 0, 0.16);
                          top: -8px;  left: 50%;
                          transform: rotate(-45deg) translateX(-50%);
                        }

                        .tooltip-content {
                          .tooltip-text {
                            font-size: 13px;
                            line-height: 1.2;
                            font-weight: 400;
                            color: #444;
                            margin-bottom: 10px;
                          }
                          .tooltip-link {
                            display: flex;
                            align-items: center;
                            font-size: 13px;
                            font-weight: 400;
                            color: #0074FF;
                            text-decoration: none;
                            margin-top: 10px;
                          }
                        }
                      }
                    }
                  }
                }

                .content-plan-detail {
                  flex-grow: 1;
                  display: grid;
                  grid-template-columns: 306px 306px;
                  column-gap: 80px;
                  row-gap: 9px;
                  .item {
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 306px;
                    font-size: 13px;
                    font-weight: 600;
                    line-height: 1.15;
                    color: #444;
                    z-index: 1;
                    &:before {
                      content: '';
                      position: absolute;
                      top: 50%;
                      transform: translateY(-50%);
                      left: 0;
                      z-index: -1;
                      width: 99%;
                      height: 1px;
                      background-image: linear-gradient(to right,transparent 50%, #D7D7D7 50%);
                      background-size: 5px 1px;
                    }
                    span {
                      background-color: #fff;
                    }
                    .frame {
                      background-color: #fff;
                    }
                    &:lang(en), &:lang(ja) {
                      &.user_journey, &.marketing {
                        width: 400px;
                      }
                    }
                  }
                }
                &.selected {
                  outline: 2px solid #4497F7;
                  border-color: transparent;
                  box-shadow: 0px 11px 17px -3px rgba(0, 0, 0, 0.16);
                  .content-card-check {
                    position: absolute;
                    top: 24px;
                    right: 24px;
                    width: 20px;
                    height: 20px;
                    background: url("https://dream-cdn.beusable.net/home/images/icon-check-green.svg") no-repeat center center;
                    background-size: cover;
                  }
                }

                &.disabled {
                  pointer-events: none;
                  opacity: 0.3;
                }
              }
            }
            &.referral {
              padding: 30px 40px 6px;
              text-align: left;
              .referral-title {
                @include flexYcenter;
                margin-bottom: 18px;
                gap: 6px;
                color: #2F2F2F;
                font-size: 15px;
                font-weight: 700;
                .referral-benefit {
                  position: relative;
                  margin-left: 23px;
                  color: #777;
                  font-size: 12px;
                  font-weight: 400;
                  &:before {
                    content: '';
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    left: -12px;
                    width: 1px;
                    height: 12px;
                    background-color: #D7D7D7;
                  }
                }
              }
              .referral-next {
                display: inline-flex;
                align-items: center;
                height: 28px;
                padding: 0px 8px 0px 10px;
                gap: 4px;
                color: #0E90A5;
                font-size: 12px;
                font-weight: 600;
                border-radius: 4px;
                border: 1px solid #BBB;
                &.disabled {
                  pointer-events: none;
                  opacity: 0.3;
                }
                button {
                  display: flex;
                }
              }
              .referral-code {
                @include flexYcenter;
                gap: 20px;
                /deep/ .input--wrap {
                  width: 287px;
                  margin: 0;
                  .label {
                    display: none;
                  }
                }
                .get-code-button {
                  @include flexYcenter;
                  gap: 4px;
                  color: #0E90A5;
                  font-size: 13px;
                  &.disabled {
                    pointer-events: none;
                    opacity: .2;
                  }
                }
              }
              .referral-term {
                position: relative;
                &-header {
                  @include flexYcenter;
                  margin-top: 32px;
                  /deep/ .ui_checkbox {
                    margin: 0;
                  }
                  .term-title {
                    color: #2F2F2F;
                    font-size: 13px;
                    font-weight: 400;
                    line-height: 120%;
                    .link {
                      text-decoration: underline;
                      color: #2F2F2F;
                    }
                    .necessary {
                      color: $brandColor;
                    }
                  }
                  .term-toggle {
                    display: flex;
                    margin-left: 8px;
                    &.opened {
                      .icon {
                        transform: rotate(180deg);
                      }
                    }
                  }

                  .term-error {
                    color: #E60724;
                    font-size: 12px;
                    font-weight: 500;
                    line-height: 1.5;
                    margin-left: 24px;
                  }
                }
                .term-list {
                  display: flex;
                  flex-direction: column;
                  gap: 4px;
                  padding: 20px 20px 20px 30px;
                  margin-top: 12px;
                  border-radius: 5px;
                  border: 1px solid #d7d7d7;
                  background-color: #f4f4f4;
                  box-sizing: border-box;
                  color: #444;
                  font-size: 12px;
                  line-height: 1.5;
                  list-style-type: disc;
                }
              }
            }
            &:first-child {
              border: 0;
              padding-top: 0;
            }
          }
        }
        .custom-plan-insert-wrapper {
          .guideText {
            text-align: left;
            position: relative;
            color: #2F2F2F;
            font-size: 15px;
            padding: 7px 0 8px;
          }
          .insert-wrapper {
            display: flex;
            gap: 24px;
            padding: 27px 0;
            .insert-item {
              flex-grow: 1;
              display: flex;
              align-items: center;
              .label {
                color: #2f2f2f;
                width: 153px;
                flex-shrink: 0;
                font-size: 24px;
                font-weight: 700;
                text-align: left;
              }
              .input-wrap {
                position: relative;
                flex-grow: 1;
                position: relative;
                max-width: 290px;
                border-radius: 8px;
                border: 1px solid #AFAFAF;
                background-color: #FFF;
                padding: 14px;

                color: #666 !important;
                font-size: 24px;
                font-weight: 700;
                line-height: 1;
                display: flex;
                align-items: center;
                gap: 5px;
                input {
                    width: 100%;
                    border: 0;
                    outline: 0;
                    padding: 0;
                    text-align: right;
                    font: inherit;
                    color: #666;
                    flex-grow: 1;
                }
                &:after {
                    content: attr(unit);
                    flex-shrink: 0;
                    font: inherit;
                    line-height: 1.2;
                }
                .errorMsg {
                  position: absolute;
                  top: 100%;
                  left: 0;
                  margin-top: 5px;
                  color: #e60724;
                  font-size: 13px;

                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
